import {makeActionCreators} from '../redux';

/**
 * @param {ReactReduxModalOptions} options
 * @return {ReactReduxModalActions}
 */
export function buildActions(options) {
  return makeActionCreators(options.prefix, [{
    name: 'showModal',
    type: 'SHOW_MODAL',
  }, {
    name: 'hideModal',
    type: 'HIDE_MODAL',
  }]);
}

/**
 * @typedef {Object<String, Function|ReduxActionCreator>} ReactReduxModalActions
 * @property {Function|ReduxActionCreator<Void>} showModal
 * @property {Function|ReduxActionCreator<Void>} hideModal
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-redux-modals/actions.js